  
    
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Send Email Notification
    <button mat-icon-button (click)="closeSendReminder()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="search">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput maxlength="200" placeholder="Add email" [(ngModel)]="repeatTaskEmail">
        </mat-form-field>
      </div>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeSendReminder()">Cancel</button>
    <button mat-flat-button color="primary" 
    (click)="onSendManualTaskReminder()">
    Send
  </button>
  </mat-dialog-actions>
 
  

  




